/* ==========================================================================
   LOGO SIZE MOCKUP TOOL — CRO / lead-capture layer
   Sits on top of the untouched engine (assets/mockup-tool.js) via its small
   public API: window.MockupTool.{hasLogo,hasBackground,getSummary,
   getCompositeBlob,getCompositeDataURL}.

   Does:
     • Soft gate — Download / Email / Share require an email once (remembered).
     • Uploads the composited mockup to Uploadcare → public shareable URL.
     • Fires Klaviyo:  identify(email) + track('Created Logo Mockup', {mockup_url,...})
       so client-side Klaviyo flows can email the result + nurture.
     • "Get a quote for this size" deep-links into the existing quote form,
       pre-filled with the logo's width/height.
     • Pushes GTM dataLayer events for measurement.
   ========================================================================== */
(function () {
  var app = document.querySelector('.mt-app');
  if (!app || !window.MockupTool) {
    document.addEventListener('mockup:ready', init, { once: true });
    return;
  }
  init();

  function init() {
    var app = document.querySelector('.mt-app');
    if (!app || app.dataset.croInit) return;
    app.dataset.croInit = '1';

    var UC_KEY = (app.dataset.uploadcareKey || '').trim();
    var UC_ENABLED = UC_KEY && UC_KEY !== 'YOUR_UPLOADCARE_PUBLIC_KEY';
    // Project CDN domain (files are served here, NOT the shared ucarecdn.com)
    var UC_CDN = (app.dataset.uploadcareCdn || 'https://ucarecdn.com').replace(/\/+$/, '');
    var QUOTE_URL = app.dataset.quoteUrl || '/products/custom-wall-stickers-design-service';
    var LS_KEY = 'mt_lead_v1';

    var $ = function (id) { return document.getElementById(id); };
    var engineDownloadBtn = $('downloadBtn');   // hidden — engine's real downloader
    var btnDownload = $('mtDownloadBtn');
    var btnEmail = $('mtEmailBtn');
    var btnShare = $('mtShareBtn');
    var btnQuote = $('mtQuoteBtn');

    var capModal = $('mtCaptureModal');
    var capForm = $('mtCaptureForm');
    var capName = $('mtcName');
    var capEmail = $('mtcEmail');
    var capCompany = $('mtcCompany');
    var capConsent = $('mtcConsent');
    var capPreview = $('mtcPreview');
    var capSub = $('mtcSub');
    var capSubmit = $('mtcSubmit');

    var shareModal = $('mtShareModal');
    var sharePreview = $('mtsPreview');
    var shareUrlInput = $('mtShareUrl');
    var copyBtn = $('mtCopyBtn');
    var shareWa = $('mtShareWhatsapp');
    var shareEmailLink = $('mtShareEmailLink');
    var shareDownload = $('mtShareDownload');
    var shareQuote = $('mtShareQuote');
    var shareTitle = $('mtsTitle');

    var pendingAction = null;

    /* ---------------- lead persistence ---------------- */
    function getLead() { try { return JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { return null; } }
    function setLead(lead) { try { localStorage.setItem(LS_KEY, JSON.stringify(lead)); } catch (e) {} }
    function hasLead() { var l = getLead(); return !!(l && l.email); }

    /* ---------------- tiny toast (Bootstrap is loaded) ---------------- */
    function toast(msg, variant) {
      variant = variant || 'primary';
      try {
        var el = document.createElement('div');
        el.className = 'toast align-items-center text-bg-' + variant + ' border-0';
        el.setAttribute('role', 'status');
        el.innerHTML = '<div class="d-flex"><div class="toast-body">' + msg + '</div>' +
          '<button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button></div>';
        document.getElementById('toasts').appendChild(el);
        var t = new bootstrap.Toast(el, { delay: 4000 }); t.show();
        el.addEventListener('hidden.bs.toast', function () { el.remove(); });
      } catch (e) { /* no-op */ }
    }

    /* ---------------- analytics ---------------- */
    function track(event, data) {
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: event }, data || {})); } catch (e) {}
    }

    /* ---------------- Klaviyo (onsite already loaded by the app embed) ---------------- */
    function klaviyoIdentify(lead) {
      try {
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', {
          '$email': lead.email,
          '$first_name': lead.name || '',
          'Company': lead.company || '',
          'Accepts Marketing': !!lead.consent
        }]);
      } catch (e) {}
    }
    function klaviyoTrack(name, props) {
      try { window._learnq = window._learnq || []; window._learnq.push(['track', name, props || {}]); } catch (e) {}
    }

    /* ---------------- Uploadcare (composite → public URL) ---------------- */
    function uploadComposite() {
      return window.MockupTool.getCompositeBlob('image/png').then(function (blob) {
        if (!blob) return null;
        if (!UC_ENABLED) return null; // no host configured yet
        var fd = new FormData();
        fd.append('UPLOADCARE_PUB_KEY', UC_KEY);
        fd.append('UPLOADCARE_STORE', 'auto');
        fd.append('file', blob, 'logo-mockup.png');
        return fetch('https://upload.uploadcare.com/base/', { method: 'POST', body: fd })
          .then(function (r) { if (!r.ok) throw new Error('upload'); return r.json(); })
          .then(function (j) { return UC_CDN + '/' + j.file + '/logo-mockup.png'; });
      });
    }

    /* ---------------- modal helpers ---------------- */
    function openModal(m) { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function closeModal(m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    document.querySelectorAll('[data-mt-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeModal(el.closest('.mt-modal')); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeModal(capModal); closeModal(shareModal); } });

    function setPreview(imgEl) {
      window.MockupTool.getCompositeDataURL().then(function (url) { if (url && imgEl) imgEl.src = url; });
    }

    /* ---------------- quote deep-link ---------------- */
    function quoteHref() {
      var s = window.MockupTool.getSummary();
      var url = QUOTE_URL;
      if (s.logo_w_cm && s.logo_h_cm) {
        url += (url.indexOf('?') > -1 ? '&' : '?') + 'w=' + s.logo_w_cm + '&h=' + s.logo_h_cm;
      }
      return url;
    }
    function refreshQuoteLinks() { var h = quoteHref(); if (btnQuote) btnQuote.href = h; if (shareQuote) shareQuote.href = h; }

    /* ---------------- gate + actions ---------------- */
    function requireMockup() {
      if (!window.MockupTool.hasLogo()) { toast('Upload your logo first to build a mockup.', 'warning'); return false; }
      return true;
    }

    function gate(action) {
      if (!requireMockup()) return;
      pendingAction = action;
      if (hasLead()) { runAction(action); }
      else {
        capSub.textContent = action === 'download'
          ? "Pop in your details and we'll unlock the HD download."
          : action === 'email'
            ? "Enter your email and we'll send this mockup straight to your inbox."
            : "Enter your details to get a shareable link for your team.";
        setPreview(capPreview);
        openModal(capModal);
        setTimeout(function () { capName.focus(); }, 50);
      }
    }

    function runAction(action) {
      var summary = window.MockupTool.getSummary();
      track('mockup_' + action + '_click', summary);

      if (action === 'download') {
        // Download straight away, then log the mockup event in the background
        engineDownloadBtn.click();
        fireMockupEvent(action).catch(function () {});
        return;
      }

      // Email + Share need the hosted image before we can show the result
      var btn = action === 'email' ? btnEmail : btnShare;
      var oldHtml = btn.innerHTML; btn.disabled = true; btn.innerHTML = 'Working…';
      fireMockupEvent(action).then(function (url) {
        if (url) {
          openShare(url, action);
        } else if (action === 'email') {
          toast("Your details are saved and we'll be in touch. Your mockup will download now.", 'primary');
          engineDownloadBtn.click();
        } else {
          toast('Sharing needs image hosting enabled. Downloading your mockup instead.', 'warning');
          engineDownloadBtn.click();
        }
      }).catch(function (e) {
        console.error(e);
        toast('Something went wrong preparing the image. Your mockup will download instead.', 'danger');
        engineDownloadBtn.click();
      }).then(function () { btn.disabled = false; btn.innerHTML = oldHtml; });
    }

    // Uploads the composited mockup and fires the Klaviyo + GTM event.
    // Runs for every action (download / email / share) so lead notifications
    // are consistent. Returns the hosted image URL (or null if hosting is off).
    function fireMockupEvent(action) {
      return uploadComposite().then(function (url) {
        var summary = window.MockupTool.getSummary();
        klaviyoTrack('Created Logo Mockup', Object.assign({ mockup_url: url || '', action: action, tool: 'logo-size-mockup' }, summary));
        track('mockup_created', Object.assign({ action: action, mockup_url: url || '' }, summary));
        return url;
      });
    }

    function openShare(url, action) {
      refreshQuoteLinks();
      setPreview(sharePreview);
      shareUrlInput.value = url;
      shareTitle.textContent = action === 'email' ? 'Sent, check your inbox' : 'Your mockup is ready to share';
      var msg = encodeURIComponent('Check out our logo mockup: ' + url);
      shareWa.href = 'https://wa.me/?text=' + msg;
      shareEmailLink.href = 'mailto:?subject=' + encodeURIComponent('Our logo mockup') + '&body=' + msg;
      shareDownload.href = url;
      openModal(shareModal);
    }

    /* ---------------- capture form submit ---------------- */
    capForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var okName = (capName.value || '').trim().length > 0;
      var okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((capEmail.value || '').trim());
      capName.closest('.mt-field').classList.toggle('is-invalid', !okName);
      capEmail.closest('.mt-field').classList.toggle('is-invalid', !okEmail);
      if (!okName || !okEmail) return;

      var lead = {
        name: capName.value.trim(),
        email: capEmail.value.trim(),
        company: (capCompany.value || '').trim(),
        consent: !!capConsent.checked
      };
      setLead(lead);
      klaviyoIdentify(lead);
      track('mockup_email_captured', { has_consent: lead.consent });
      closeModal(capModal);
      var action = pendingAction || 'email';
      runAction(action);
    });

    /* ---------------- copy link ---------------- */
    copyBtn.addEventListener('click', function () {
      shareUrlInput.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      if (navigator.clipboard) { navigator.clipboard.writeText(shareUrlInput.value).catch(function () {}); ok = true; }
      copyBtn.textContent = ok ? 'Copied!' : 'Copy';
      setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1600);
    });

    /* ---------------- wire buttons ---------------- */
    if (btnDownload) btnDownload.addEventListener('click', function () { gate('download'); });
    if (btnEmail) btnEmail.addEventListener('click', function () { gate('email'); });
    if (btnShare) btnShare.addEventListener('click', function () { gate('share'); });
    if (btnQuote) btnQuote.addEventListener('click', function () { track('mockup_quote_click', window.MockupTool.getSummary()); });

    /* ---------------- keep quote link + button states current ---------------- */
    function syncButtons() {
      var ready = window.MockupTool.hasLogo();
      [btnEmail, btnShare, btnDownload].forEach(function (b) { if (b) b.disabled = !ready; });
      refreshQuoteLinks();
    }
    document.addEventListener('mockup:updated', syncButtons);
    syncButtons();

    // one-time entry event for measurement
    track('mockup_tool_view', {});
  }
})();
